// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reset-password-dialog[data-v-7e71c478] .el-dialog{width:var(--common-dialog-width)}", ""]);
// Exports
module.exports = exports;
